import React, { useContext, useState } from "react";
import { calculateRectPos } from "../../../../../utis/helper";
import { EditorInfoContext } from "../../../../../utis/userInfoContext";
import useCanvasHook from "../editorHook/useCanvasHook";

const PdfCanvas = ({ canvasRefs, index, editortype, zoom }) => {
  const { draw, createDiv } = useCanvasHook();
  const {
    editEnabled,
    setOpenAddElement,
    rectangles,
    geo,
    setRectangles,
    setActiveRectangleIndex,
    setGeo,
    pageDimensions
  } = useContext(EditorInfoContext);

  const [isDrawing, setIsDrawing] = useState(false);
  const [startCoords, setStartCoords] = useState(null);

  const handleMouseDown = (event) => {
    const canvas = canvasRefs.current[index];
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();

    // keep canvas resolution in sync
    canvas.width  = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const cssX = event.clientX - rect.left;
    const cssY = event.clientY - rect.top;
    const scaleX = canvas.width  / rect.width;
    const scaleY = canvas.height / rect.height;
    const x = cssX * scaleX;
    const y = cssY * scaleY;

    setStartCoords({ x, y });
    setIsDrawing(true);

    const newRects = [...rectangles];
    newRects[index] = [
      ...newRects[index],
      { startCoords: { x, y }, currentCoords: { x, y } }
    ];
    setRectangles(newRects);
    setActiveRectangleIndex({
      pageIndex: index,
      rectIndex: newRects[index].length - 1
    });
  };

  const handleMouseMove = (event) => {
    if (!isDrawing || !startCoords) return;
    const canvas = canvasRefs.current[index];
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();

    canvas.width  = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const cssX = event.clientX - rect.left;
    const cssY = event.clientY - rect.top;
    const scaleX = canvas.width  / rect.width;
    const scaleY = canvas.height / rect.height;
    const x = cssX * scaleX;
    const y = cssY * scaleY;

    const newRects = [...rectangles];
    const last = newRects[index][newRects[index].length - 1];
    last.currentCoords = { x, y };

    setRectangles(newRects);
    draw(index, canvasRefs, zoom);
  };

  const handleMouseUp = (event) => {
    if (!isDrawing || !startCoords) return;
    setIsDrawing(false);

    const canvas = canvasRefs.current[index];
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();

    // keep canvas resolution in sync
    canvas.width  = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    const cssX = event.clientX - rect.left;
    const cssY = event.clientY - rect.top;
    const scaleX = canvas.width  / rect.width;
    const scaleY = canvas.height / rect.height;
    const endX = cssX * scaleX;
    const endY = cssY * scaleY;

    // KEEP RECT VISIBLE: update state with final coords
    const newRects = [...rectangles];
    const last = newRects[index][newRects[index].length - 1];
    last.currentCoords = { x: endX, y: endY };
    setRectangles(newRects);

    //  KEEP RECT VISIBLE: redraw so it stays on canvas
    draw(index, canvasRefs, zoom);

    setOpenAddElement(true);

    // calculate relative to PDF page
    const position = calculateRectPos(
      startCoords.x,
      startCoords.y,
      endX,
      endY
    );

    if (position.width > 2 && position.height > 2) {
      const { width: pageW, height: pageH } = pageDimensions;
      const baseW = window.objInit.canvas_base_width || pageW;
      const baseH = window.objInit.canvas_base_height || pageH;

      const relativeRect = {
        left:   (position.left   / pageW) * baseW,
        top:    (position.top    / pageH) * baseH,
        width:  (position.width  / pageW) * baseW,
        height: (position.height / pageH) * baseH,
        page: index + 1
      };

      setGeo({ ...geo, ...relativeRect });
      createDiv(position, index, canvasRefs);
    }
  };

  return (
    <canvas
      ref={el => (canvasRefs.current[index] = el)}
      id={index + 1}
      style={{
        position:      "absolute",
        top:           0,
        left:          0,
        height:        pageDimensions.height,
        width:         pageDimensions.width,
        ...(editortype !== "stats-viewer"
          ? { height: pageDimensions.height, width: pageDimensions.width }
          : { width: "100%", height: "100%" }),
        zIndex:        editEnabled ? 999 : 2,
        pointerEvents: "auto",
        cursor:        editEnabled ? "crosshair" : "default"
      }}
      onMouseDown={e => editEnabled && handleMouseDown(e)}
      onMouseMove={e => editEnabled && handleMouseMove(e)}
      onMouseUp={e   => editEnabled && handleMouseUp(e)}
    />
  );
};

export default PdfCanvas;


